// Afișare preț: 2 zecimale cu punct (99.86, 99.70); sumele întregi fără zecimale (200, 10)
export const formatPrice = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
};
